import { ActionReducerMap, combineReducers, compose } from '@ngrx/store';
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import * as t from './reducer';

export const featureStateKey = 'auth-core';

export interface AuthFeatureStateUnion {
  auth: t.AuthFeatureState;
}

export const reducers: ActionReducerMap<AuthFeatureStateUnion> = {
  auth: t.authReducer,
};

export function store(state: any, action: any): AuthFeatureStateUnion {
  const actionReducer = compose(combineReducers)(reducers);
  return actionReducer(state, action);
}
